module.exports = __webpack_public_path__ + "img/Menu-06.55a41590.png";